<template>
    <div
        v-if="(rows && rows.length)"
        class="card card-rounded card-bg-yellow mb-5 d-print-none"
    >
        <div class="card-body">
            <h3 class="text-center">
                {{ $filters.striphtml(title) }}
            </h3>

            <div
                v-for="component in components"
                :key="component.id"
                class="no-break"
            >
                <p
                    v-if="(component.translations && component.translations.length)"
                    class="my-0"
                >
                    <strong>{{ component.translations[0].title }}</strong>:
                    <span v-html="component.translations[0].content"></span>
                </p>

                <p
                    v-else
                    class="my-0"
                >
                    <strong>{{ component.title }}</strong>:
                    <span v-html="component.content"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        type: {
            type: String,
            default: '',
        },
        lessonId: {
            type: [Number, String],
            required: true,
        },
        languageId: {
            type: [Number, String],
            required: true,
        },
    },

    data() {
        return {
            isLoading: null,
            rows: [],
        };
    },

    computed: {
        titleComponent: function() {
            // get the title component
            return this.rows[0];
        },
        title: function() {
            // get the original OR translated title
            return (this.titleComponent.translations.length ? this.titleComponent.translations[0].content : this.titleComponent.content);
        },
        components: function() {
            // get components, except the first one
            return this.rows.slice(1);
        },
    },

    watch: {
        languageId: function () {
            this.getRows();
        },
    },

    mounted: function () {
        this.getRows();
    },

    methods: {
        getRows: function () {
            this.isLoading = true;
            this.rows = [];

            axios({
                method: 'get',
                url: `/subscriber/api/lessons/${this.lessonId}/components/`,
                params: {
                    language_id: (this.languageId || this.$app.translationEnglishId),
                    type: this.type,
                },
            })
            .then((response) => {
                this.rows = response.data;
                this.isLoading = false;
            });
        },
    },
};
</script>

<style scoped>
    p
    {
        margin-bottom: 0 !important;
    }
</style>
